import React from 'react';
import styles from './index.less';

const Arrow = ({ green, up, small = false }) => {
  const path = up
    ? 'M8.5,1.5 8.5,12.5 M5,5 8.5,1.5 12,5'
    : 'M8.5,1.5 8.5,12.5 M5,9 8.5,12.5 12,9';
  const stroke = green ? '#00a150' : '#d0021b';

  const viewBox = small ? "0 0 8 8" : "0 0 16 16";
  return (
    <svg className={styles.icon} viewBox={viewBox}>
      <path d={path} fill="none" stroke={stroke} />
    </svg>
  );
};

export default Arrow;
